import React, { SetStateAction, useContext, useEffect, useState } from "react"
import {
  LegalPersonFormFieldNameEnum,
  LegalPersonFormType,
} from "@/types/LegalPersonForm"
import { Input } from "components/ui/input"
import { ErrorMessage } from "@hookform/error-message"
import { Controller, useForm } from "react-hook-form"
import PhoneInput, { handleValidate } from "components/common/phoneInput/PhoneInput"
import {
  AllDefaultValues,
  CLIENT_ADD_STEPS,
} from "@/types/StepForm"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"
import ModalForm from "components/common/modal/ModalForm"
import { useAppDispatch } from "@/hooks/reduxToolkitHook"
import { asyncAddLegalPerson } from "@/redux/features/companiesSlice"
import {
  ActionNotificationContext,
  ActionNotificationContextValeurType,
} from "@/context/ActionNotificationContext"
import { getCompany } from "@/requests/companiesRequests"
import { CompanyType1 } from "@/types/CompaniesType"
import { InvoiceType } from "@/types/InvoicesType"

export interface LegalPersonModalFormProps {
  isModalOpen: boolean;
  handleModalClose: () => void;
  representative?: LegalPersonFormType;
}

function LegalPersonModalForm({
  isModalOpen,
  handleModalClose,
  representative,
}: LegalPersonModalFormProps): JSX.Element {
  const {id} = useParams()
  const dispatch = useAppDispatch()
  const { setCompany } = useOutletContext<any>()

  const { displayAlert } = useContext(
    ActionNotificationContext,
  ) as ActionNotificationContextValeurType
  const [countryCode, setCountryCode] = useState<string>("bj")

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<LegalPersonFormType>({
    defaultValues: AllDefaultValues[1],
    mode: "all",
  })

  const submitForm = (formData : LegalPersonFormType) =>{
    try{
      dispatch(asyncAddLegalPerson({ companyId: id as string, data: formData })).then((result) => {
        if (asyncAddLegalPerson.fulfilled.match(result)) {
          displayAlert("Operation effectuée avec succès", "success")
          reset()
          getCompany(id).then((response) => {
            setCompany(response.data)
          })
          handleModalClose()
        } else if (asyncAddLegalPerson.rejected.match(result)) {
          displayAlert(
            "Une erreur est survenue lors de l'ajout d'un representant légal",
            "error"
          )
        }
      })
    }catch(error) {
      displayAlert("Une erreur est survenue lors de l'ajout d'un representant légal","error")
    }
  }

  useEffect(() => {
    if(representative){
      setValue(LegalPersonFormFieldNameEnum.FIRST_NAME, representative.first_name)
      setValue(LegalPersonFormFieldNameEnum.LAST_NAME, representative.last_name)
      setValue(LegalPersonFormFieldNameEnum.EMAIL, representative.email)
      setValue(LegalPersonFormFieldNameEnum.CONTACT, representative.phone_number)
      setValue(LegalPersonFormFieldNameEnum.POSITION, representative.position)
    }
    setValue("company_country", "bj");
  }, [])

  useEffect(() => {
    reset()
    if(representative){
      setValue(LegalPersonFormFieldNameEnum.FIRST_NAME, representative.first_name)
      setValue(LegalPersonFormFieldNameEnum.LAST_NAME, representative.last_name)
      setValue(LegalPersonFormFieldNameEnum.EMAIL, representative.email)
      setValue(LegalPersonFormFieldNameEnum.CONTACT, representative.phone_number)
      setValue(LegalPersonFormFieldNameEnum.POSITION, representative.position)
    }
  }, [isModalOpen])


  return (
    <ModalForm
      title="Créer un contact référent"
      description=""
      open={isModalOpen}
      onClose={handleModalClose}
      formSubmit={handleSubmit(submitForm)}
      submitButtonLabel="Sauvegarder"
      withFooter>
      <form>
        <div className="space-y-2">
          <div className="pt-2">
            <label htmlFor={LegalPersonFormFieldNameEnum.FIRST_NAME}>
              Prénoms
            </label>
            <Input
              placeholder="Prénoms"
              type="text"
              {...register(LegalPersonFormFieldNameEnum.FIRST_NAME, {
                required: "Cette valeur est requise.",
              })}
            />
            <ErrorMessage
              errors={errors}
              name={LegalPersonFormFieldNameEnum.FIRST_NAME}
              as="p"
              className="text--error"
            />
          </div>
          {/*<div className="pt-2">
              <Controller
                name="birthday"
                control={control}
                render={({ field }) => (
                  <>
                    <div className="flex flex-col mt-10">
                      <label className="mb-4 font-medium">Date de naissance*</label>
                      <MuiDatePicker
                        {...field}
                        className="flex--3"
                        disableFuture={true}
                        minDate={new Date("1922-01-01")}
                        selected={field.value}
                        views={["day", "month", "year"]}
                        onYearChange={(value) => field.onChange(value)}
                      />
                    </div>
                    <div className="flex flex-col mt-2 mb-7">
                  <span className="">
                    <FormInfo
                      infoText={`Age à ce jour : 78 ans`}
                    />
                    {field.value && getValues("first_name") === "" && (
                      <FormInfo
                        infoText={`Age à ce jour : ${getAge(field.value)} ans`}
                      />
                    )}
                    {field.value && getValues("first_name") !== "" && (
                      <FormInfo
                        infoText={<div className="flex "><p className="uppercase">{getValues("last_name")}</p> <p
                          className="mx-1 capitalize">{getValues("first_name")}</p> a {getAge(field.value)} ans à ce jour
                        </div>} />
                    )}
                  </span>
                    </div>
                  </>
                )}
              />
            </div>*/}

          <div className="pt-2">
            <label htmlFor={LegalPersonFormFieldNameEnum.LAST_NAME}>
              Nom
            </label>
            <Input
              placeholder="Nom"
              type="text"
              {...register(LegalPersonFormFieldNameEnum.LAST_NAME, {
                required: "Cette valeur est requise.",
              })}
            />
            <ErrorMessage
              errors={errors}
              name={LegalPersonFormFieldNameEnum.LAST_NAME}
              as="p"
              className="text--error"
            />
          </div>

          <div>
            <label htmlFor={LegalPersonFormFieldNameEnum.EMAIL}>
              Email du dirigeant
            </label>
            <Controller
              name={LegalPersonFormFieldNameEnum.EMAIL}
              control={control}
              rules={{
                required: "L'email est requis.",
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "Entrez un email valid",
                },
              }}
              render={({ field }) => (
                <Input
                  placeholder="adresse@mail.com"
                  type="email"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            <ErrorMessage
              errors={errors}
              name={LegalPersonFormFieldNameEnum.EMAIL}
              as="p"
              className="text--error"
            />
          </div>

          <div>
            <label className="">Numéro du dirigeant</label>
            <Controller
              name={LegalPersonFormFieldNameEnum.CONTACT}
              control={control}
              rules={{
                required: "Veuillez renseigner votre numéro de téléphone",
                validate: (value) =>
                  handleValidate(value, countryCode) ||
                  "Le numéro n'est pas valide pour le pays sélectionné",
              }}
              render={({ field }) => (
                <PhoneInput
                  defaultCountry={"bj"}
                  isCodeEditable={false}
                  onChange={(
                    value: any,
                    country: { countryCode: SetStateAction<string> }
                  ) => {
                    setCountryCode(country.countryCode)
                    field.onChange(value)
                  }}
                  value={field.value}
                />
              )}
            />
            <ErrorMessage
              errors={errors}
              name={LegalPersonFormFieldNameEnum.CONTACT}
              as="p"
              className="text--error"
            />
          </div>

          <div className="pt-2">
            <label htmlFor={LegalPersonFormFieldNameEnum.POSITION}>
              Poste
            </label>
            <Input
              placeholder="Poste"
              type="text"
              {...register(LegalPersonFormFieldNameEnum.POSITION, {
                required: "Cette valeur est requise.",
              })}
            />
            <ErrorMessage
              errors={errors}
              name={LegalPersonFormFieldNameEnum.POSITION}
              as="p"
              className="text--error"
            />
          </div>

          <p className="text-sm mt-6">
            Les informations que vous aurez saisies doivent correspondre
            exactement avec celles présentes sur le justificatif d’identité
            déposé. Il ne doit s’agir d’un pseudo ni d’un nom d’usage.
          </p>
        </div>
      </form>
    </ModalForm>
  )
}

export default LegalPersonModalForm